import { IconDefinition } from "./types";

const chevronLeft: IconDefinition = {
  iconName: "chevron-left",
  width: 384,
  height: 512,
  svgPathData:
    "M22.5 256l17-17 200-200 17-17 33.9 33.9-17 17-183 183 183 183 17 17-33.9 33.9-17-17-200-200-17-17z",
  iconType: "fill",
  fontAwesomeName: "chevron-left",
  unicode: 0xf053,
};

export { chevronLeft };
